import React from "react";

import s from "./about.module.scss";
import logo from "./logo.png";
import { DivPx } from "@moai/core";

const Team = () => (
    <a
        className={s.link}
        href="https://tableplus.com"
        target="_blank"
        rel="noopener noreferrer"
    >
        TablePlus Team
    </a>
);

const Body = () => (
    <div className={s.body}>
        <div>Developed and maintained</div>
        <DivPx size={4} />
        <div>
            <span>by </span>
            <Team />
        </div>
    </div>
);

const Logo = () => (
    <a
        className={s.logo}
        href="https://tableplus.com"
        target="_blank"
        rel="noopener noreferrer"
    >
        <img alt="tableplus logo" src={logo} width="auto" height={32} />
    </a>
);

interface Props {
    reverse?: boolean;
}

export const About: React.FC<Props> = ({ reverse }) => (
    <div className={reverse ? s.reverse : ""}>
        <div className={s.container}>
            <Body />
            <DivPx size={16} />
            <Logo />
        </div>
    </div>
);
